import { ReactNode, useState } from "react";
import {
  PopoverContent,
  PopoverPortal,
  PopoverTrigger,
  Root,
} from "@radix-ui/react-popover";
import clsx from "clsx";
import { ETaskType } from "screens/Campaigns/types";

type TProps = {
  availableTypes: string[];
  onTypeClick: (type: string) => void;
  children: ReactNode;
};

export const TypesDropdown = ({
  children,
  availableTypes,
  onTypeClick,
}: TProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Root open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverPortal>
        <PopoverContent asChild className="bg-[#111111] w-[406px] z-[10]">
          <div
            className="overflow-auto custom-scrollbar max-h-[300px]"
          >
            {availableTypes.map((availableType, index) => (
              <div
                className={clsx(
                  "capitalize p-2 flex gap-4 items-center hover:bg-[#FFFFFF1A] cursor-pointer hover:text-[#FFC93D]",
                )}
                key={index}
                onClick={() => {
                  onTypeClick(availableType)
                  setIsOpen(false)
                }}
              >
                {availableType === ETaskType.JOIN_DS_CHANNEL ? "Join Discord Channel" : availableType}
              </div>
            ))}
          </div>
        </PopoverContent>
      </PopoverPortal>
    </Root>
  );
};
